// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","wrapper":"BDEqtT5A9cFQIMrM_WaTR","container":"_34Dvh2o7ybfNt-UwCc0I1x","edit":"H_F1noFRcJGfvgUjJuzdi","text":"_2bixmwbWzmon5nMrm6c8ND","buttons-section":"_339ldxx-ARRUicjoVnAJRA","button":"_38UNCoHREm_vHAG1gygC4U","button-icon":"_1Gcqw7NjJJzuwP9IeLWjlV","button-text":"V2XbSMXrednqW2vcIyYNM","delete-button":"fhbFZX6jJdRvIPygHUYvd","edit-button":"_2GmyNevEMZ0aQxkfrL4OQR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/components/SkillBlock.mod.css
// module id = 1784
// module chunks = 0